import { createSlice } from "@reduxjs/toolkit";

const appSlice = createSlice({
    name: "app",
    initialState: {
        config: {},
        flags: {
            isODSEnabled: false,
        },
    },
    reducers: {
        configure(state, action) {
            state.config = action.payload;
        },
        setFlag(state, action) {
            const { flag, value } = action.payload;
            state.flags[flag] = value;
        },
    },
});

export const { configure, setFlag } = appSlice.actions;

export default appSlice.reducer;
